import React, {ReactNode} from 'react';
import style from './style.module.scss';

type TGalleryOverlayBarProps = {
    leftSlot: ReactNode;
    centralSlot: ReactNode;
    rightSlot: ReactNode;
};

export const GalleryOverlayBar = (props: TGalleryOverlayBarProps) => {
    const {leftSlot, rightSlot, centralSlot} = props;

    return (
        <div className={style.main} data-skeleton-item={''}>
            <div className={style.left}>{leftSlot}</div>
            <div className={style.center}>{centralSlot}</div>
            <div className={style.right}>{rightSlot}</div>
        </div>
    );
};
